import { Error } from '@/components/flows/Error';
import { LegalEntityRelationFlow } from '@/components/flows/LegalEntityRelationFlow';
import { Loading } from '@/components/flows/Loading';
import { Pending } from '@/components/flows/Pending';
import { TestLegalEntityPartner } from '@/components/flows/TestLegalEntityPartner';
import { TestLegalEntityRepresentative } from '@/components/flows/TestLegalEntityRepresentative';
import { TestNaturalPerson } from '@/components/flows/TestNaturalPerson';
import { TheEnd } from '@/components/flows/TheEnd';
import Header from '@/components/globals/Header';
import { RegistryBootstrap } from '@/components/globals/RegistryBootstrap';
import { Wizard } from '@/components/Wizard';
import useAuthStore from '@/stores/auth';

const BlululupContent = () => {
  const currentUser = useAuthStore(({ currentUser }) => currentUser);

  if (!currentUser) {
    return null;
  }

  // const flow = pickFlow(currentUser.document);

  return (
    <>
      <Header />

      {/* <Wizard defaultSelected={flow}> */}
      <Wizard>
        <Wizard.FlowList name='natural-person'>
          <TestNaturalPerson />
          <TheEnd />
        </Wizard.FlowList>

        <Wizard.FlowList name='legal-entity'>
          <LegalEntityRelationFlow />
        </Wizard.FlowList>

        <Wizard.FlowList name='legal-entity-partner-validated'>
          <TestLegalEntityPartner />
          <TheEnd />
        </Wizard.FlowList>

        <Wizard.FlowList name='legal-entity-representative'>
          <TestLegalEntityRepresentative />
          <Pending />
        </Wizard.FlowList>

        <Wizard.FlowList name='loading'>
          <Loading />
        </Wizard.FlowList>

        <Wizard.FlowList name='error'>
          <Error />
        </Wizard.FlowList>
      </Wizard>
    </>
  );
};

const Blululup = () => (
  <RegistryBootstrap>
    <BlululupContent />
  </RegistryBootstrap>
);

export default Blululup;
